import type {
  TShopCommissionResponseServer,
  TShopCommissionServer,
  TShopCommissionResponse,
  TShopCommission,
} from '../../store/types';

const shopCommissionItemAdapter = (item: TShopCommissionServer): TShopCommission => ({
  id: item.id,
  shopId: item.shop_id,
  shopName: item.shop_name,
  paymentMethodId: item.payment_method_id,
  paymentMethodName: item.payment_method_name,
  refillPercent: Number(item.refill_percent),
  additionalPercent: Number(item.additional_percent),
});

export const shopCommissionsAdapter = (res: TShopCommissionResponseServer): TShopCommissionResponse => ({
  count: res.count,
  items: res.items.map(shopCommissionItemAdapter),
});
